import _styled from "styled-components";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Flex } from "../layout";
import { Context } from "./Form.js";
import FieldError from "./FieldError.js";
import { SPACE } from "../../constants/style";
import { HelpText } from "../text";

var Field = function Field(props) {
  var _validation$name, _validation$name2;

  var children = props.children,
      name = props.name,
      helpText = props.helpText,
      rest = _objectWithoutProperties(props, ["children", "name", "helpText"]);

  var _useContext = useContext(Context),
      validation = _useContext.validation,
      state = _useContext.state,
      onFieldBlur = _useContext.onFieldBlur;

  var _ref = state || {},
      touched = _ref.touched,
      validateAll = _ref.validateAll;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTouched = _useState2[0],
      setIsTouched = _useState2[1]; // eslint-disable-next-line


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      debugMode = _useState4[0],
      setDebugMode = _useState4[1];

  var fieldValidation = {
    errors: validation ? (_validation$name = validation[name]) === null || _validation$name === void 0 ? void 0 : _validation$name.errors : [],
    warnings: validation ? (_validation$name2 = validation[name]) === null || _validation$name2 === void 0 ? void 0 : _validation$name2.warnings : [],
    isTouched: touched && touched[name] ? true : false
  };
  var showValidation = validateAll || fieldValidation.isTouched || isTouched;
  var errors = fieldValidation.errors,
      warnings = fieldValidation.warnings;
  var hasError = Boolean(errors === null || errors === void 0 ? void 0 : errors.length); // eslint-disable-next-line

  var hasWarning = Boolean(warnings === null || warnings === void 0 ? void 0 : warnings.length);
  return React.createElement(_StyledFlex, _extends({
    flex: "0 0 auto",
    direction: "column"
  }, rest), React.createElement(Flex, {
    flex: "0 0 auto"
  }, React.Children.map(children, function (child) {
    return React.cloneElement(child, {
      fullWidth: true,
      onBlur: function onBlur() {
        setIsTouched(true);
        onFieldBlur(name);
      }
    });
  })), helpText ? React.createElement(Flex, {
    flex: "0 0 auto"
  }, React.createElement(HelpText, null, helpText)) : null, showValidation ? React.createElement(Flex, {
    flex: "0 0 auto"
  }, warnings !== null && warnings !== void 0 && warnings.length ? warnings.map(function (w) {
    return React.createElement("div", {
      key: w,
      style: {
        marginTop: SPACE.sm
      }
    }, w);
  }) : null, errors !== null && errors !== void 0 && errors.length ? errors.map(function (e) {
    return React.createElement(FieldError, {
      key: e
    }, e);
  }) : null) : null, debugMode ? React.createElement("pre", null, JSON.stringify(fieldValidation, null, 2), React.createElement("br", null), "validateAll: ", validateAll ? 'true' : 'false', React.createElement("br", null), "showValidation: ", showValidation ? 'true' : 'false', React.createElement("br", null), "showError: ", showValidation && hasError ? 'true' : 'false') : null);
};

__signature__(Field, "useContext{{validation, state, onFieldBlur}}\nuseState{[isTouched, setIsTouched](false)}\nuseState{[debugMode, setDebugMode](false)}");

Field.defaultProps = {
  errors: [],
  warnings: [],
  fullWidth: false
};
Field.propTypes = {
  name: PropTypes.string,
  fullWidth: PropTypes.bool
};
var _default = Field;
export default _default;

var _StyledFlex = _styled(Flex).withConfig({
  displayName: "Field___StyledFlex",
  componentId: "sc-y84saz-0"
})(["max-width:100%;width:100%;"]);

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Field, "Field", "/home/vsts/work/1/s/src/components/forms/Field.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/forms/Field.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();